<template>
  <div class="collect universal">
    <h1 class="page-title">已收藏资源 · {{date_content.totalCount||0}}</h1>
    <TimeSearch @SearchData="SearchData" />

    <None v-if="date_content.apiSourceList==null || date_content.apiSourceList.length==0" />
    <div v-else>
      <CollectResourseItem
        v-for="item,index in date_content.apiSourceList"
        :key="item.id"
        :dateObject="item"
        :index="(index + 1 + (pageInfo.current - 1) * pageInfo.pageSize)"
        @change="change=!change"
      />
    </div>
    <DevPagination
      class="margin-top-66"
      :total="date_content.totalCount"
      :pageSize="6"
      :change="change"
      @currentChange="postDate"
    />
  </div>
</template>

<script>
import DevPagination from "@/components/Base/DevPagination.vue";
import CollectResourseItem from "@/components/Resourse/CollectResourseItem.vue";
import TimeSearch from "@/components/Base/TimeSearch.vue";
import None from "@/components/Base/None.vue";
import { getFavoriteList } from "@/utils/api";

export default {
  components: {
    DevPagination,
    CollectResourseItem,
    TimeSearch,
    None,
  },
  data() {
    return {
      date_content: {
        totalCount: 0,
      },
      search_info: "",
      change: false,
      pageInfo: "",
    };
  },
  methods: {
    postDate(page) {
      this.pageInfo = page;
      this.date_content.apiSourceList = [];
      this.$store.dispatch("changeLoading", true);
      getFavoriteList({
        pageNum: page.current,
        pageSize: page.pageSize,
        searchWord: this.search_info,
      }).then((response) => {
        this.$store.dispatch("changeLoading", false);
        this.date_content = response.data;
      });
    },
    SearchData(e) {
      this.search_info = e;
      this.change = !this.change;
    },
  },
};
</script>

<style lang="less" scoped>
.collect {
  .margin-top-66 {
    margin-top: 66px;
  }
}
</style>
